module.exports = __webpack_public_path__ + "img/warning-rotate-phone.1f90b56b.svg";